// @ts-check
import React, { Component } from "react"
import { BlockContextConsumer } from "./ContextProviders"

/**
 * @augments {Component<{blockId: EntityId, context: BlockContext}>}
 */
class DisplayBlockId extends Component {
    render() {
        const { blockId, children, ...otherProps } = this.props
        return (
            <span
                onClick={event => {
                    this.props.context.actions.selectBlock(blockId)
                    event.stopPropagation()
                }}
                onMouseOver={() => {
                    this.props.context.actions.highlightElement(blockId)
                }}
                onMouseLeave={() => this.props.context.actions.stopHighlight()}
                {...otherProps}
            >
                {children || blockId}
            </span>
        )
    }
}

DisplayBlockId.propTypes = {}

export default function DisplayBlockIdInContext(props) {
    return (
        <BlockContextConsumer>
            {context => <DisplayBlockId {...props} context={context} />}
        </BlockContextConsumer>
    )
}



// WEBPACK FOOTER //
// ./src/features/editor/DisplayBlockId.js